import { useQuery } from "react-query";
import { getPaymentRemittanceType } from "../../../../../actions/Utilities/PaymentRemittanceType";

export function useAgmtPaymentRemittanceType() {
  return useQuery("GetAgmtPaymentRemittanceType", getPaymentRemittanceType, {
    refetchOnWindowFocus: false,
  });
}
